import { Inject, NgModule, Optional } from '@angular/core';
import { CrosstalkModule } from '@ddv/crosstalk';
import { EntitlementsModule } from '@ddv/entitlements';
import { FiltersModule } from '@ddv/filters';
import { ApiConfiguration, defaultApiConfiguration, hostAndPortForService, HttpModule } from '@ddv/http';
import { LayoutModule } from '@ddv/layout';
import { NamedQueriesModule } from '@ddv/named-queries';
import { ReferenceDataModule } from '@ddv/reference-data';

import { ActionHandlerBodyBuilderService } from './services/action-handler-body-builder.service';
import { ActionHandlerService, removeRestFromActionPathToken } from './services/action-handler.service';
import { CrosstalkDataService } from './services/crosstalk-data.service';
import { DataFastnessService } from './services/data-fastness.service';
import { DatasetDatasetFetcherService } from './services/dataset-dataset-fetcher.service';
import { DatasetManagerService } from './services/dataset-manager.service';
import { DatasetQueryParamsDifferService } from './services/dataset-query-params-differ.service';
import { DatasetQueryRunnerService } from './services/dataset-query-runner.service';
import { DatasetQueryToRuntimeParamsConverterService } from './services/dataset-query-to-runtime-params-converter.service';
import { DatasetRefresherService } from './services/dataset-refresher.service';
import { DatasetRuntimeParamsBuilderService } from './services/dataset-runtime-params-builder.service';
import { DatasetStateManagementService } from './services/dataset-state-management.service';
import { DatasetTrebekQueryRunnerService } from './services/dataset-trebek-query-runner.service';
import { DefaultQueryParamsService } from './services/default-query-params.service';
import { MetadataService, replaceHostInActionsURLToken, trebekApiURLToken } from './services/metadata.service';
import { SlowDataApprovalService } from './services/slow-data-approval.service';
import { TrebekQueryMappingService } from './services/trebek-query-mapping.service';
import { WidgetDataSourceService } from './services/widget-datasource.service';

@NgModule({
    imports: [
        CrosstalkModule,
        EntitlementsModule,
        FiltersModule,
        HttpModule,
        LayoutModule,
        NamedQueriesModule,
        ReferenceDataModule,
    ],
    providers: [
        ActionHandlerBodyBuilderService,
        ActionHandlerService,
        CrosstalkDataService,
        DataFastnessService,
        DatasetDatasetFetcherService,
        DatasetManagerService,
        DatasetQueryParamsDifferService,
        DatasetQueryRunnerService,
        DatasetQueryToRuntimeParamsConverterService,
        DatasetRefresherService,
        DatasetRuntimeParamsBuilderService,
        DatasetStateManagementService,
        DatasetTrebekQueryRunnerService,
        DefaultQueryParamsService,
        MetadataService,
        SlowDataApprovalService,
        WidgetDataSourceService,
        TrebekQueryMappingService,
        {
            provide: replaceHostInActionsURLToken,
            useFactory: (c: ApiConfiguration): boolean => c.replaceHostInActionsURL,
            deps: [[new Inject('apiConfig'), new Optional()]],
        },
        {
            provide: trebekApiURLToken,
            useFactory: (c: ApiConfiguration | null): string => {
                const config = c ?? defaultApiConfiguration;
                if (config.replaceHostInActionsURL) {
                    const hostAndPort = hostAndPortForService(config.trebekApiLocation.hostAndPort, config.onPremApiHost);
                    return `${window.location.protocol}//${hostAndPort}/${config.trebekApiLocation.rootUri}`;
                }
                return '';
            },
            deps: [[new Inject('apiConfig'), new Optional()]],
        },
        {
            provide: removeRestFromActionPathToken,
            useFactory: (c: ApiConfiguration): boolean => c.removeRestFromActionPath,
            deps: [[new Inject('apiConfig'), new Optional()]],
        },
    ],
})
export class DatasetsModule {}
